import React, {useEffect, useState} from 'react'
import { useDispatch} from 'react-redux';
import {
    saveTemp,
    toggleModal,
    toggleModalType,
    userRegister
} from '../../redux/actions';
import CloseBtn from "../common/CloseIcon";
import {useWindowSize} from '../hooks/use-window-size'

const Register = () => {
    const [email, setEmail]  = useState('');
    const [username, setUsername]  = useState('');
    const [firstLastName, setFirstLastName] = useState('');
    //const [phone, setPhone]  = useState('');
    //const [description, setDescription] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    const dispatch = useDispatch();
    const closeModal = () => {
        dispatch(toggleModal());
    }
    const size = useWindowSize()
    let scrollHeight: number|string = '100%'
    if (size && size.height && size.height < 573) {
        scrollHeight = size.height - 20
    }
    const [height, setHeight] = useState(scrollHeight)

    useEffect(() => {
        if (size && size.height && size.height < 573) {
            setHeight(size.height - 20)
        }
    }, [size])

    const validate = () => {
        if (!password || !confirmPassword) {
            setError('Parool puudub!');
            return false;
        }
        if (!username) {
            setError('Kasutajanimi puudub!');
            return false;
        }
        if (!firstLastName) {
            setError('Ees- ja perekonnanimi puudub!');
            return false;
        }
        if (password !== confirmPassword) {
            setError('Paroolid ei klapi');
            return false;
        }

        if (!email) {
            setError('Email puudub!');
            return false;
        }
        //
        // if (!phone) {
        //     setError('Telefoni number puudub!');
        //     return false;
        // }

        setError('');
        return true;
    }

    const sendForm = async () => {
        const data = {
            firstLastName,
            username,
            email,
            //phone,
            //description,
            password,
            confirmPassword
        }
        if (!validate()) {
            return false;
        }

        const result = await userRegister(data);

        if (result.code <= 0) {
            setError(result.message);
        } else {
            //setError(result.message);
            dispatch(saveTemp({
                username: email,
                password
            }))

            dispatch(toggleModalType('registrationconfirm'));
            //dispatch(toggleModal())
        }

    }



    return <div style={{overflow: 'scroll', height: height}}>
        <div className='close-btn' onClick={closeModal}>
            <CloseBtn/>
        </div>
        <div className='login'>
            <h2 style={{marginTop:47,fontSize:'22px',fontWeight:'bold'}}>Registreeri konto!</h2>

            <div style={{margin: '36px 0'}}>
                { error ? <div className="error">{error}</div>:null }
                <div className="form-group">
                    <input
                        type="text"
                        className="form-control"
                        id="firstLastName"
                        value={firstLastName}
                        onChange={(ev)=>{setFirstLastName(ev.target.value)}}
                        placeholder="Ees- ja perekonnanimi"/>
                </div>
                <div className="form-group">
                    <input
                        type="email"
                        className="form-control"
                        id="email"
                        value={email}
                        onChange={(ev)=>{setEmail(ev.target.value)}}
                        placeholder="email"/>
                </div>
                {/*<div className="form-group">*/}
                {/*    <input*/}
                {/*        type="text"*/}
                {/*        className="form-control"*/}
                {/*        id="phone"*/}
                {/*        value={phone}*/}
                {/*        onChange={(ev)=>{setPhone(ev.target.value)}}*/}
                {/*        placeholder="telefoni nr"/>*/}
                {/*</div>*/}
                {/*<div className="form-group">*/}
                {/*    <textarea*/}
                {/*        className="form-control"*/}
                {/*        id="description"*/}
                {/*        rows={5}*/}
                {/*        value={description}*/}
                {/*        onChange={(ev)=>{setDescription(ev.target.value)}}*/}
                {/*        placeholder="Kirjelda lühidalt, milliste üritustega oled seotud"/>*/}
                {/*</div>*/}
                <div className="form-group">
                    <input
                        type="text"
                        className="form-control"
                        id="username"
                        value={username}
                        onChange={(ev)=>{setUsername(ev.target.value)}}
                        placeholder="username"/>
                </div>
                <div className="form-group">
                    <input
                        type="password"
                        className="form-control"
                        id="password"
                        value={password}
                        onChange={(ev)=>{setPassword(ev.target.value)}}
                        placeholder="vali parool"/>
                </div>
                <div className="form-group">
                    <input
                        type="password"
                        className="form-control"
                        id="confirm_password"
                        value={confirmPassword}
                        onChange={(ev)=>{setConfirmPassword(ev.target.value)}}
                        placeholder="korda parool"/>
                </div>
                <button type="button" className="btn btn-success" onClick={sendForm}>Registreeru</button>

            </div>
        </div>
    </div>

}

export default Register;
